import { render, staticRenderFns } from "./FormIf.vue?vue&type=template&id=3ad11fc4&"
import script from "./FormIf.vue?vue&type=script&lang=js&"
export * from "./FormIf.vue?vue&type=script&lang=js&"
import style0 from "./FormIf.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports